export function getUserRegistryStatusEndpoint(): string {
    return '/user-registry-status';
}
